import {DomainObject} from 'shared/store';
import {action, computed, observable} from 'mobx';
import {dateSpan, dateFormatter, formatTimeOffAmount} from 'shared/tools';
import TimeOffType from './TimeOffType';

class TimeOffLiabilityBalance extends DomainObject {
  @observable id;
  @observable accrualAdjustmentPeriodStartDate;
  @observable accrualAdjustmentPeriodEndDate;
  @observable lastDayOfWork;
  @observable available;
  @observable scheduled;
  @observable accrualAdjustment;
  @observable totalLiability;
  @observable type = {};
  
  @action merge(other) {
    super.merge(other, {
      type: TimeOffType,
      _dates: ['accrualAdjustmentPeriodStartDate', 'accrualAdjustmentPeriodEndDate', 'lastDayOfWork']
    });
  }

  @computed get availableView() {
    return formatTimeOffAmount(this.available, this.type.unit);
  }

  @computed get scheduledView() {
    return formatTimeOffAmount(this.scheduled, this.type.unit);
  }

  @computed get absoluteAccrualAdjustmentView() {
    return formatTimeOffAmount(Math.abs(this.accrualAdjustment), this.type.unit);
  }

  @computed get totalLiabilityView() {
    return formatTimeOffAmount(this.totalLiability, this.type.unit);
  }

  @computed get lastDayOfWorkView() {
    return dateFormatter(this.lastDayOfWork);
  }

  @computed get accrualAdjustmentPeriodDateRange() {
    return dateSpan(this.accrualAdjustmentPeriodStartDate, this.accrualAdjustmentPeriodEndDate, true);
  }
}

export default TimeOffLiabilityBalance;
